import type { PropsWithChildren } from 'react';

const predefinedPatterns: Record<string, string> = {
  homepage: '(\\/)?(index\\.(.*))?($|\\?)'
};

type MatchPagesProps = PropsWithChildren<{
  mode: 'exclude' | 'include';
  list?: string[];
  strict: boolean;
}>;

export function MatchPages({
  mode,
  list,
  strict = false,
  children
}: MatchPagesProps) {
  if (list?.length) {
    const patternMatched = list.some((pattern) => checkMatch(pattern, strict));
    if (
      (patternMatched && mode === 'exclude') ||
      (!patternMatched && mode === 'include')
    ) {
      return;
    }
  }

  return children;
}

function checkMatch(pattern: string, strict = false) {
  if (!pattern) return false;

  const { host, href } = document.location;

  if (isPredefinedPattern(pattern)) {
    const predefinedPattern = `${clearUrl(host)}${predefinedPatterns[pattern]}`;
    const regExp = getUrlComparingRegExp(predefinedPattern);

    return regExp.test(clearUrl(href));
  }

  if (!pattern.includes('*')) {
    return strict
      ? href === pattern || encodeURI(href).toLowerCase() === pattern
      : href.includes(pattern);
  } else {
    const realPattern = escapeRegexpWithConvertStar(clearUrl(pattern));
    const regExp = getUrlComparingRegExp(realPattern);
    return regExp.test(clearUrl(href));
  }
}

function clearUrl(url: string) {
  return url.replace(/((http|https):\/\/)|(www\.)|(\/)$/g, '');
}

function isPredefinedPattern(pattern: string) {
  return Object.prototype.hasOwnProperty.call(predefinedPatterns, pattern);
}

function escapeRegexpWithConvertStar(value: string) {
  return (
    value.replace(/[/.*+?^${}()|[\]\\]/g, (match) => {
      if (match === '*') return '(.+)';

      return `\\${match}`;
    }) + '$'
  );
}

function getUrlComparingRegExp(pattern: string) {
  return new RegExp('^' + pattern, 'u');
}
